<template>
  <div class="header-d">
    <div class="d-mask" v-if="(searchVal && isSearchShow) || (isMobile && showSearchFlag)" @click="close"></div>

    <!-- 顶栏 -->
    <div class="d-top">
      <router-link to="/" class="d-brand">
        <img v-if="showLogo" class="logo-hd" :src="logo" :alt="brandName" @error="logoError = true" />
        <template v-else>
          <span class="mk">{{ markLetter }}</span>
          <span class="nm">{{ brandName }}</span>
        </template>
      </router-link>

      <template v-if="!isMobile">
        <router-link to="/" class="d-navlink" :class="{ on: isHome }">{{ $t('home') }}</router-link>
        <a href="javascript:;" class="d-navlink" :class="{ on: activeType === '4' }" @click="goCatalog('4')">{{ $t('game_top_up') }}</a>
        <a href="javascript:;" class="d-navlink" :class="{ on: activeType === '5' }" @click="goCatalog('5')">{{ $t('game_vouchers') }}</a>
        <router-link to="/mobile" class="d-navlink" :class="{ on: isMobileTopup }">{{ $t('mobile_nav') }}<span class="new">{{ $t('new_badge') }}</span></router-link>

        <div class="search-wrap">
          <SearchBox
            ref="search"
            :searchVal="searchVal"
            :clear="clearValue"
            :placeholder="searchPlaceholder"
            @onsearch="handleSearch"
          />
          <div class="d-search-panel" v-if="searchVal && isSearchShow">
            <div class="hd" v-if="gameListInfo.length > 0">{{ gameListInfo.length }} results</div>
            <ul v-if="gameListInfo.length > 0">
              <li v-for="item in gameListInfo" :key="item.id" @click="toPayCheckout(item.id)">
                <span class="th"><img :src="picUrl(item.gamePic)" alt="" /></span>
                <span>
                  <p class="nm" v-html="highlightedItem(item.gameName)"></p>
                  <div class="sb">{{ item.gameId }}</div>
                </span>
              </li>
            </ul>
            <div class="empty" v-else>
              <div class="ic-wrap">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <circle cx="11" cy="11" r="7" /><path d="m20 20-3.6-3.6" />
                </svg>
              </div>
              <h5>{{ $t('no_results_found') }}</h5>
            </div>
          </div>
        </div>
      </template>

      <div class="rt">
        <div class="d-icobtn" v-if="isMobile && !showSearchFlag" @click="showSearch">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <circle cx="11" cy="11" r="7" /><path d="m20 20-3.6-3.6" />
          </svg>
        </div>
        <a-dropdown placement="bottomRight" :trigger="['click']">
          <a class="d-lang" href="javascript:;" @click="(e) => e.preventDefault()">
            <i :class="'icon-country icon-country-' + country.toString().toLowerCase()"></i>
            <span class="txt">{{ country }}</span>
            <a-icon type="down" />
          </a>
          <a-menu class="d-langmenu" slot="overlay" @click="changeLang">
            <a-menu-item v-for="item in lang" :key="item.key">
              <a href="javascript:;">
                <i :class="`icon-country icon-country-${item.label}`"></i>
                {{ item.label }}
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>

    <!-- 移动端展开的搜索行 -->
    <div class="d-searchrow" v-if="isMobile && showSearchFlag">
      <SearchBox
        ref="searchMobile"
        :searchVal="searchVal"
        :clear="clearValue"
        :placeholder="searchPlaceholder"
        @onsearch="handleSearch"
      />
      <div class="d-search-panel" v-if="searchVal && isSearchShow">
        <ul v-if="gameListInfo.length > 0">
          <li v-for="item in gameListInfo" :key="item.id" @click="toPayCheckout(item.id)">
            <span class="th"><img :src="picUrl(item.gamePic)" alt="" /></span>
            <span>
              <p class="nm" v-html="highlightedItem(item.gameName)"></p>
              <div class="sb">{{ item.gameId }}</div>
            </span>
          </li>
        </ul>
        <div class="empty" v-else>
          <h5>{{ $t('no_results_found') }}</h5>
        </div>
      </div>
    </div>

    <!-- 移动端底部 Tab -->
    <nav class="d-tabbar" v-if="isMobile">
      <router-link to="/" :class="{ on: isHome }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 10.5 12 3l9 7.5V21H3z" /></svg>
        {{ $t('home') }}
      </router-link>
      <a href="javascript:;" :class="{ on: activeType === '4' }" @click="goCatalog('4')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></svg>
        {{ $t('game_top_up') }}
      </a>
      <a href="javascript:;" :class="{ on: activeType === '5' }" @click="goCatalog('5')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="7" width="18" height="12" rx="2.5" /><path d="M3 11h18M8 7V4M16 7V4" /></svg>
        {{ $t('game_vouchers') }}
      </a>
      <!-- 搜索在顶栏右上角还有入口，这一格让给话费 -->
      <router-link to="/mobile" :class="{ on: isMobileTopup }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="6" y="2.5" width="12" height="19" rx="2.5" /><path d="M11 18h2" /></svg>
        {{ $t('mobile_nav') }}
      </router-link>
    </nav>
  </div>
</template>

<script>
import SearchBox from './components/searchD.vue'
import i18n from '../i18n'
import utils from '@/assets/js/common'
import dh from '@/assets/js/dHelpers'
import env from '../assets/js/env'

export default {
  components: { SearchBox },
  data() {
    return {
      showSearchFlag: false,
      isMobile: false,
      brandName: env.brandName,
      logo: env.logo,
      logoError: false,
      searchVal: '',
      isSearchShow: false,
      country: 'EN',
      lang: [{ key: 'en-US', label: 'EN' }],
      gameListInfo: [],
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    // 优先展示配置里的 logo，图挂了或没配才退回字母标记
    showLogo() {
      return !!this.logo && !this.logoError
    },
    markLetter() {
      return (this.brandName || 'L').trim().charAt(0).toUpperCase()
    },
    isHome() {
      return this.$route.path === '/'
    },
    isMobileTopup() {
      return this.$route.path.startsWith('/mobile')
    },
    activeType() {
      if (!this.$route.path.startsWith('/catalog')) return ''
      return this.$route.query.type || '4'
    },
    searchPlaceholder() {
      return this.$t('search')
    },
  },
  mounted() {
    this.isMobile = dh.isMobileUA()

    const currentLang = localStorage.getItem('lang')

    // 语言列表按域名动态拼，与 A/B/C 保持一致
    if (this.currency == null) {
      const localHost = location.host;
      if (localHost.indexOf('la') > 0) {
        this.lang.push({ key: 'pt-BR', label: 'BR' }, { key: 'es-MX', label: 'MX' })
      } else if (localHost.indexOf('th') > 0) {
        this.lang.push({ key: 'th-TH', label: 'TH' })
      } else if (localHost.indexOf('ph') > 0) {
        this.lang.push({ key: 'fil-PH', label: 'PH' })
      } else if (localHost.indexOf('pg') > 0) {
        this.lang.push(
          { key: 'my-MM', label: 'MM' },
          { key: 'ms-MY', label: 'MY' },
          { key: 'vi-VN', label: 'VN' },
        )
      } else {
        this.lang.push({ key: 'id-ID', label: 'ID' })
      }
    } else {
      const currencyEnum = utils.getCurrencyByCode(this.currency)
      this.lang.push({ key: currencyEnum.language, label: currencyEnum.country })
    }

    this.lang.forEach(element => {
      if (currentLang && currentLang.indexOf(element.key) !== -1) {
        this.country = element.label
        i18n.locale = element.key
        this.$global.lang = element.label
        this.$store.commit('setCountry', element.label);
      }
    });
  },
  methods: {
    picUrl(pic) {
      return dh.gamePic(pic)
    },
    close() {
      this.isSearchShow = false;
      this.showSearchFlag = false;
    },
    showSearch() {
      this.showSearchFlag = !this.showSearchFlag;
    },
    clearValue() {
      this.searchVal = '';
    },
    clearChildValue() {
      const ref = this.$refs.search || this.$refs.searchMobile
      if (ref) ref.clearValue();
    },
    goCatalog(type) {
      this.showSearchFlag = false;
      if (this.$route.path === '/catalog' && this.$route.query.type === type) return;
      this.$router.push({ path: '/catalog', query: { type } })
    },
    toPayCheckout(gameId) {
      this.showSearchFlag = false;
      this.clearChildValue()
      this.isSearchShow = false;
      this.$router.push({ path: `/topup/${gameId}` })
    },
    highlightedItem(gameName) {
      if (!this.searchVal) return gameName;
      const pattern = new RegExp(`(${this.searchVal})`, 'gi');
      return gameName.replace(pattern, '<span class="highlighted">$1</span>');
    },
    handleSearch(keyword) {
      this.searchVal = keyword
      this.fuzzyQuery(keyword)
    },
    // 搜索接口
    fuzzyQuery(gameId) {
      if (gameId === '') {
        this.isSearchShow = false;
        return;
      }
      this.isSearchShow = false;
      const formdata = {
        gameName: gameId,
        lang: this.country != null && this.country != '' ? this.country.toString().toLowerCase() : 'en',
      }
      this.$httpReqest('/tikishop/game/fuzzyQuery', formdata)
        .then((res) => {
          if (res.code == '200') {
            this.gameListInfo = res.gameListInfo || []
            this.isSearchShow = true;
          } else {
            console.log(res.msg)
          }
        })
        .catch((err) => {
          console.log('fuzzyQuery err!', err)
        })
    },
    // 菜单 key 用语言码而不是下标，避免同级重复 key
    changeLang(obj) {
      const item = this.lang.find(l => l.key === obj.key)
      if (!item) return;
      this.country = item.label
      localStorage.setItem('lang', JSON.stringify(item.key))
      i18n.locale = item.key
      this.$global.lang = item.label;
      this.$store.commit('setCountry', item.label);
    },
  },
}
</script>

<style lang="scss" scoped>
.header-d {
  position: relative;
  z-index: 20;
}

.d-brand {
  text-decoration: none;
}

.search-wrap {
  position: relative;
  flex: 1;
  max-width: 440px;
  margin-left: 14px;
}

.rt {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.d-searchrow {
  position: relative;
}
</style>
